export default "__VITE_ASSET__CpHwNZ5o__";